import type { StoreProductVariant } from "@medusajs/types";

type ProductVariantWithStock = StoreProductVariant & {
    in_stock?: boolean;
};

export function isProductVariantAvailable(
    variant?: ProductVariantWithStock | null,
) {
    if (!variant) return false;
    if (variant.allow_backorder) return true;
    if (variant.manage_inventory === false) return true;

    if (typeof variant.inventory_quantity === "number") {
        return variant.inventory_quantity > 0;
    }

    return variant.in_stock === true;
}

export function isProductVariantAvailableOnMarketplaces(
    variant: StoreProductVariant | null | undefined,
    marketplaces: readonly unknown[] = [],
) {
    return Boolean(variant && Array.isArray(marketplaces) && marketplaces.length);
}

export function getProductVariantPurchaseSource(
    variant: StoreProductVariant | null | undefined,
    isInClickAndCollectChannel: boolean,
    marketplaces: readonly unknown[] = [],
): "click-and-collect" | "marketplace" | "offline" {
    if (isInClickAndCollectChannel && (variant?.inventory_quantity ?? 0) > 0) {
        return "click-and-collect";
    }
    return isProductVariantAvailableOnMarketplaces(variant, marketplaces)
        ? "marketplace"
        : "offline";
}

export function getFirstAvailableProductVariant(
    variants?: ProductVariantWithStock[] | null,
    isAvailable: (variant: ProductVariantWithStock) => boolean = isProductVariantAvailable,
) {
    return variants
        ?.toSorted((left, right) => {
            const leftSequence = left.metadata?.sequence;
            const rightSequence = right.metadata?.sequence;

            return (
                (typeof leftSequence === "number"
                    ? leftSequence
                    : Number.MAX_SAFE_INTEGER) -
                (typeof rightSequence === "number"
                    ? rightSequence
                    : Number.MAX_SAFE_INTEGER)
            );
        })
        .find((variant) => isAvailable(variant));
}
